import { useMemo } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { ProductHorizontalListSummaryView } from './ProductHorizontalListSummaryView';

interface ProductHorizontalListSummaryViewGroupProps {
  products: IProduct[];
  category: 'pluva' | 'partner' | 'open-market';
  pageType: 'home' | 'pdp' | 'odp';
  currentProductForMarketAmpliEvent?: Pick<IProduct, 'category' | 'code'>;
}

export const ProductHorizontalListSummaryViewGroup = ({
  products,
  category,
  pageType,
  currentProductForMarketAmpliEvent,
}: ProductHorizontalListSummaryViewGroupProps) => {
  return (
    <Wrapper id={'home-product-swiper-container'}>
      <CustomSwiper
        slidesPerView={'auto'}
        // 슬라이드 사이의 간격
        spaceBetween={16}
        // 전체보기 컴포넌트 사용을 위한 Swiper 우측 공간 크기 확보
        slidesOffsetAfter={166}
      >
        {products.map((product, index) => (
          <CustomSwiperSlide key={product.id}>
            <ProductHorizontalListSummaryView
              key={product.id}
              product={product}
              currentProductForMarketAmpliEvent={currentProductForMarketAmpliEvent}
              listType={pageType}
            />
            {index === products.length - 1 && (
              <GoToListPageButton pageType={pageType} category={category} height={217} />
            )}
          </CustomSwiperSlide>
        ))}
      </CustomSwiper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);
  min-height: 217px;

  padding: 0px 16px;

  transform: translateX(-16px);

  gap: 16px;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  height: 217px;
  width: 142px !important;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;

  cursor: pointer;
  @media screen and (max-width: 340px) {
    width: 130px !important;
  }
`;
